import { SidebarMenuButton, useSidebar } from '@/components/shadcn/sidebar'
import { useAudioPlayer } from '@/hooks/useAudioPlayer'
import { Headphones, Subtract } from '@mynaui/icons-react'
import { useEffect } from 'react'
import { Loader } from '../Loader'
import AudioControls from './AudioControls'
export type AudioPlayerProps = {
  isPopout?: boolean
}

const AudioPlayer = ({ isPopout = false }: AudioPlayerProps) => {
  // Destructure everything the hook returns
  const {
    isPopoutOpen,
    isLoading,
    isFetching,
    currentTitle,
    currentArtist,
    currentDuration,
    currentProgress,
    isPlaying,
    handlePlayPause,
    toNextTrack,
    toPrevTrack,
    onScrub,
    onScrubEnd,
    openPopout,
  } = useAudioPlayer(isPopout)
  const { open } = useSidebar()

  useEffect(() => {
    handlePlayPause(false)
  }, [])

  return isPopoutOpen && !isPopout ? null : open ? (
    <div className="flex justify-start items-center px-4 py-3 gap-2 rounded-xl shadow-lg w-full transition-all">
      {/* Artwork / Loader */}
      <div className="bg-customConicGradient w-8 h-8 rounded-lg overflow-hidden flex-shrink-0 mx-auto my-auto">
        {isLoading || isFetching ? (
          <div className="flex w-full h-full items-center justify-center">
            <Loader />
          </div>
        ) : (
          <img src={'/artwork.jpg'} alt={currentTitle || 'Artwork'} className="w-full h-full object-cover rounded-lg" />
        )}
      </div>

      {/* Track info & controls */}
      <div className="flex flex-col gap-2 items-start w-full">
        <div className="flex gap-2 justify-between items-center w-full">
          <div className="flex flex-col gap-0">
            <h4 className="text-xs font-semibold">
              {isLoading || isFetching ? 'Loading...' : currentTitle || 'Unknown'}
            </h4>
            <p className="text-xs text-gray-500">{isLoading || isFetching ? '' : currentArtist || ''}</p>
          </div>
          <div className={isLoading || isFetching ? 'opacity-50 pointer-events-none' : ''}>
            <AudioControls
              isPlaying={isPlaying}
              onPrevClick={toPrevTrack}
              onNextClick={toNextTrack}
              onPlayPauseClick={(play) => handlePlayPause(play)}
            />
          </div>
        </div>

        {/* Progress bar + Popout button */}
        <div className="w-full flex items-center gap-2">
          <input
            type="range"
            value={currentProgress}
            step="1"
            min="0"
            max={currentDuration || 0}
            onChange={(e) => onScrub(Number(e.target.value))}
            onMouseUp={onScrubEnd}
            onKeyUp={onScrubEnd}
            className="w-full h-2"
            disabled={isLoading || isFetching}
          />
          {!isPopout && (
            <Subtract
              className="w-6 h-6 cursor-pointer"
              onClick={(e) => {
                e.stopPropagation()
                openPopout()
              }}
            />
          )}
        </div>
      </div>
    </div>
  ) : (
    <SidebarMenuButton
      className="w-6 h-6 cursor-pointer mx-auto mb-2"
      onClick={(e) => {
        e.stopPropagation()
        openPopout()
      }}
    >
      <Headphones />
    </SidebarMenuButton>
  )
}

export default AudioPlayer
